// ChangePassword.tsx
import React, { useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button, Form } from "react-bootstrap";
import { Password } from "primereact/password";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../Redux/Store";
import { useAlert } from "./Alert.tsx";
import { urlutenti } from "../lib/api.ts";
import { allPatch, allPut } from "../Redux/Actions.tsx";
import "./PasswordDimenticata.css";
import { logout } from "../Redux/Reducers/LoginReducer.ts";
import { useNavigate } from "react-router-dom";

interface ChangePasswordProps {
  visible: boolean;
  onHide: () => void;
}

const ChangePassword: React.FC<ChangePasswordProps> = ({ visible, onHide }) => {
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [repeatNewPassword, setRepeatNewPassword] = useState("");
  const [errors, setErrors] = useState({
    oldPassword: false,
    newPassword: false,
    repeatNewPassword: false,
  });
  const [confirmDialogVisible, setConfirmDialogVisible] = useState(false);
  const navigate = useNavigate();
  const dispatch: AppDispatch = useDispatch();
  const { token, profilo } = useSelector((state: RootState) => state.login);

  const showAlert = useAlert();

  const handleLogout = () => {
    navigate("/");
    setTimeout(() => {
      dispatch(logout());
    }, 1000);
  };

  const validateFields = () => {
    const newErrors = {
      oldPassword: !oldPassword.trim(),
      newPassword: !newPassword.trim(),
      repeatNewPassword: !repeatNewPassword.trim(),
    };

    if (newPassword !== repeatNewPassword) {
      showAlert("danger", "Errore", "Le password non coincidono.", "bottom-end", 3000);
      newErrors.newPassword = true;
      newErrors.repeatNewPassword = true;
    }

    setErrors(newErrors);
    return !Object.values(newErrors).some((error) => error);
  };

  const handleConfirm = () => {
    setConfirmDialogVisible(false);

    const body = {
      vecchiaPassword: oldPassword,
      nuovaPassword: newPassword,
    };

    dispatch(allPatch(`${urlutenti}/${profilo.id}/cambia-password`, token, body, showAlert)).then((response) => {
      if (response) {
        showAlert("success", "Successo", "Password cambiata con successo.", "bottom-end", 3000);
        onHide();
        handleLogout();
      } else {
        showAlert("danger", "Errore", "Errore nel cambiare la password.", "bottom-end", 3000);
      }
    });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if (validateFields()) {
      setConfirmDialogVisible(true);
    }
  };

  const errorStyle = {
    border: "1px solid red",
  };

  return (
    <>
      <Dialog
        visible={visible}
        header="Cambia Password"
        onHide={onHide}
        style={{ width: "400px" }}
        footer={
          <div>
            <Button className="button" onClick={handleSubmit}>
              Conferma
            </Button>
            <Button variant="secondary" className="button-annulla s-bet" onClick={onHide}>
              Annulla
            </Button>
          </div>
        }
      >
        <p>Inserisci la password attuale e la nuova password</p>
        <Form>
          <Form.Group controlId="oldPassword" className="mb-3">
            <Form.Label>Password attuale</Form.Label>
            <Password
              value={oldPassword}
              onChange={(e) => {
                setOldPassword(e.target.value);
                setErrors((prev) => ({ ...prev, oldPassword: false }));
              }}
              placeholder="Password attuale"
              toggleMask
              feedback={false}
              style={{ width: "100%", display: "block", height: "46px", borderRadius: "8px" }}
              inputStyle={{
                width: "100%",
                height: "46px",
                display: "block",
                borderRadius: "8px",
                ...(errors.oldPassword ? errorStyle : {}),
              }}
            />
          </Form.Group>

          <Form.Group controlId="newPassword" className="mb-3">
            <Form.Label>Nuova password</Form.Label>
            <Password
              value={newPassword}
              onChange={(e) => {
                setNewPassword(e.target.value);
                setErrors((prev) => ({ ...prev, newPassword: false }));
              }}
              placeholder="Nuova password"
              toggleMask
              style={{ width: "100%", display: "block", height: "46px", borderRadius: "8px" }}
              inputStyle={{
                width: "100%",
                height: "46px",
                display: "block",
                borderRadius: "8px",
                ...(errors.newPassword ? errorStyle : {}),
              }}
            />
          </Form.Group>

          <Form.Group controlId="repeatNewPassword" className="mb-3">
            <Form.Label>Ripeti nuova password</Form.Label>
            <Password
              value={repeatNewPassword}
              onChange={(e) => {
                setRepeatNewPassword(e.target.value);
                setErrors((prev) => ({ ...prev, repeatNewPassword: false }));
              }}
              placeholder="Ripeti nuova password"
              toggleMask
              style={{ width: "100%", display: "block", height: "46px", borderRadius: "8px" }}
              inputStyle={{
                width: "100%",
                height: "46px",
                display: "block",
                borderRadius: "8px",
                ...(errors.repeatNewPassword ? errorStyle : {}),
              }}
            />
          </Form.Group>
        </Form>
      </Dialog>

      <Dialog
        visible={confirmDialogVisible}
        header="Conferma"
        onHide={() => setConfirmDialogVisible(false)}
        style={{ width: "350px" }}
        footer={
          <div>
            <Button className="button s-bet" onClick={handleConfirm}>
              Sì
            </Button>
            <Button variant="secondary" className="button-annulla" onClick={() => setConfirmDialogVisible(false)}>
              No
            </Button>
          </div>
        }
      >
        <p>Sicuro di voler modificare la password?</p>
      </Dialog>
    </>
  );
};

export default ChangePassword;
